import React from "react";
import Slider from "react-slick";
import Media from "react-media";
import _includes from "lodash/includes";
//
import Modal from "./Modal";
import Icon from "./Icon";
import Button from "./Button";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

function CarousalImage({ id, path, verified, onReport, reported }) {
  reported = false;
  return (
    <div className="carousal__image">
      <img src={path} />
      {verified && (
        <small className="ribbon-tag ribbon-tag--top-left">
          Verified Photo
          <Icon name="check" small />
        </small>
      )}
      {!reported && (
        <div className="carousal__report">
          <Button
            icon="report"
            title="Report"
            small
            mod={["basic", "rev"]}
            onClick={(ev) => onReport(id)}
          />
        </div>
      )}
    </div>
  );
}

const Carousal = ({
  model,
  isPremium,
  isOpen,
  onClose,
  onReport,
  imagesReported,
  initialSlide,
}) => {
  settings.initialSlide = initialSlide;

  return (
    <Modal isOpen={isOpen} className="carousal" noHead>
      <Button
        icon="close"
        mod="link"
        className="modal__close"
        onClick={onClose}
      />
      <div className="carousal__slick">
        <Media query={{ minDeviceWidth: 414, maxDeviceWidth: 736 }}>
          {(match) =>
            match ? (
              <Slider {...settings}>
                {model.images.map((image, i) => (
                  <div key={image.id}>
                    <CarousalImage
                      id={image.id}
                      // path={`/escorts/${model.hash}/images/ip6+/${image.path}`}
                      path={`/images/ip6+/${image.path}`}
                      verified={isPremium && image.verified === 1}
                      onReport={onReport}
                      reported={_includes(imagesReported, image.id)}
                    />
                  </div>
                ))}
              </Slider>
            ) : (
              <Media query={{ minDeviceWidth: 375, maxDeviceWidth: 667 }}>
                {(match) =>
                  match ? (
                    <Slider {...settings}>
                      {model.images.map((image, i) => (
                        <div key={image.id}>
                          <CarousalImage
                            id={image.id}
                            // path={`/escorts/${model.hash}/images/ip6/${image.path}`}
                            path={`/images/ip6/${image.path}`}
                            verified={isPremium && image.verified === 1}
                            onReport={onReport}
                            reported={_includes(imagesReported, image.id)}
                          />
                        </div>
                      ))}
                    </Slider>
                  ) : (
                    <Media query={{ minDeviceWidth: 320, maxDeviceWidth: 568 }}>
                      {(match) =>
                        match ? (
                          <Slider {...settings}>
                            {model.images.map((image, i) => (
                              <div key={image.id}>
                                <CarousalImage
                                  id={image.id}
                                  // path={`/escorts/${model.hash}/images/ip5/${image.path}`}
                                  path={`/images/ip5/${image.path}`}
                                  verified={isPremium && image.verified === 1}
                                  onReport={onReport}
                                  reported={_includes(imagesReported, image.id)}
                                />
                              </div>
                            ))}
                          </Slider>
                        ) : (
                          <Media query={{ minWidth: 720 }}>
                            {(match) =>
                              match ? (
                                <Slider {...settings}>
                                  {model.images.map((image, i) => (
                                    <div key={image.id}>
                                      <CarousalImage
                                        id={image.id}
                                        // path={`/escorts/${model.hash}/images/lg/${image.path}`}
                                        path={`/images/lg/${image.path}`}
                                        verified={
                                          isPremium && image.verified === 1
                                        }
                                        onReport={onReport}
                                        reported={_includes(
                                          imagesReported,
                                          image.id
                                        )}
                                      />
                                    </div>
                                  ))}
                                </Slider>
                              ) : (
                                <Media query={{ minWidth: 320 }}>
                                  {(match) =>
                                    match ? (
                                      <Slider {...settings}>
                                        {model.images.map((image, i) => (
                                          <div key={image.id}>
                                            <CarousalImage
                                              id={image.id}
                                              // path={`/escorts/${model.hash}/images/mobile/${image.path}`}
                                              path={`/images/mobile/${image.path}`}
                                              verified={
                                                isPremium &&
                                                image.verified === 1
                                              }
                                              onReport={onReport}
                                              reported={_includes(
                                                imagesReported,
                                                image.id
                                              )}
                                            />
                                          </div>
                                        ))}
                                      </Slider>
                                    ) : (
                                      <span />
                                    )
                                  }
                                </Media>
                              )
                            }
                          </Media>
                        )
                      }
                    </Media>
                  )
                }
              </Media>
            )
          }
        </Media>
      </div>
    </Modal>
  );
};

export default Carousal;
